import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../environments/environment';
import { AuthService } from './auth.service';

export interface HubSpotConfiguration {
  identificationEmail: string;
  identificationToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class HubSpotConfigurationService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  public getHubSpotConfiguration(): Observable<HubSpotConfiguration | null> {
    return this.http.get<HubSpotConfiguration | null>(
      environment.API_URL + '/api/hubspot-configuration',
      {
        headers: {
          authorization: 'Bearer ' + this.authService.accessToken
        }
      }
    );
  }
}
